module.exports = __webpack_public_path__ + "HP_Latex_1000-2000.jpg?64cf131a16f2b9541255a9fe398a1092";